




export class SecondRequest {
    apTypeId: string;
    apTypeName: string;
    miApTypeName: string;
    secondRequest: string;
    is4DigitsCustomItem: boolean;
    mainTypeName: string;
    typeCode: string;


    constructor(apTypeId: string, apTypeName: string, miApTypeName: string, secondRequest: string, is4DigitsCustomItem: boolean = false, mainTypeName: string = '', typeCode: string = '') {
        this.apTypeId = apTypeId;
        this.apTypeName = apTypeName;
        this.miApTypeName = miApTypeName;
        this.secondRequest = secondRequest;
        this.is4DigitsCustomItem = is4DigitsCustomItem;
        this.mainTypeName = mainTypeName;
        this.typeCode = typeCode;
    }
}